import { MultiSelectMode } from '../../../types/types';
import { getSubsetAndItemParams } from '../../../utils/getSubsetAndItemParams';

type BulkFormExitRefetchParams = {
  multiSelectMode: MultiSelectMode;
  isExitingForms: boolean;
  submitted: boolean;
  isSubsetFormToken: boolean;
  returnUrl: string;
};

export const shouldRefetchAfterBulkFormExit = ({
  multiSelectMode,
  isExitingForms,
  submitted,
  isSubsetFormToken,
  returnUrl,
}: BulkFormExitRefetchParams): boolean => {
  if (!isExitingForms || !submitted) return false;
  if (multiSelectMode !== 'bulk') return false;
  // A subset form must never refetch the master dataset.
  if (isSubsetFormToken) return false;
  // A page-1 refetch would drop the viewed detail row from the loaded window.
  if (returnUrl.includes('/detail/')) return false;

  // A row or subset in the return url means an existing locate flow refetches instead.
  const { itemId, subsetId } = getSubsetAndItemParams(returnUrl);

  return itemId === undefined && subsetId === undefined;
};
